export enum ChatroomStatus {
  NEW = 'new',
  DELETED = 'deleted',
  STARTED = 'started' /* Plan to deprecate */,
  CLOSED = 'closed' /* Plan to deprecate */,
  START_LATER = 'start_later' /* Plan to deprecate */,
}
